import React from 'react'
import "./Home.css"
import { Link } from 'react-scroll'

const Home = () => {
    return (
        <>

            <section id='main'>
                <div className="container-fluid p-0 " >
                    <div id="carouselExampleFade" className="carousel slide carousel-fade" data-bs-ride="carousel" >
                        <div className="carousel-inner Inter-Font-Family" >
                            <div className="carousel-item active Same-Img-Size" style={{ backgroundImage: `url(${require("../Img/HomeSlide1.webp")})`, backgroundAttachment: "local", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: 'top' }}>
                                <div className='d-flex justify-content-start align-items-end w-100 h-100' style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                                    <div className='Main-Silder-Content-Second'>
                                        <h1>
                                            Where Beauty, Skill, and Style Come Together
                                        </h1>
                                        <div className=''>
                                            <p>
                                                Transform your look and your career  with P.A.S. Glam Beauty Studio & Institute,
                                                a premier destination for Makeup, Hair, and Beautician Courses in Pune.
                                            </p>
                                        </div>
                                        <div className='Home-Silder-btn-Main '>
                                            <Link to="services">
                                                <button className='HomeSlideBtn1'>
                                                    See Our Services
                                                </button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="carousel-item  Same-Img-Size" style={{ backgroundImage: `url(${require("../Img/HomeSlide2.webp")})`, backgroundAttachment: "local", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: 'top' }}>
                                <div className='d-flex justify-content-start align-items-end w-100 h-100' style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                                    <div className='Main-Silder-Content-Second'>
                                        <h1>
                                            Where Beauty, Skill, and Style Come Together
                                        </h1>
                                        <div className=''>
                                            <p>
                                                Transform your look and your career  with P.A.S. Glam Beauty Studio & Institute,
                                                a premier destination for Makeup, Hair, and Beautician Courses in Pune.
                                            </p>
                                        </div>
                                        <div className='Home-Silder-btn-Main '>
                                            <Link to="services">
                                                <button className='HomeSlideBtn1'>
                                                    See Our Services
                                                </button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="carousel-item  Same-Img-Size" style={{ backgroundImage: `url(${require("../Img/HomeSlide3.webp")})`, backgroundAttachment: "local", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: 'top' }}>
                                <div className='d-flex justify-content-start align-items-end w-100 h-100' style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                                    <div className='Main-Silder-Content-Second'>
                                        <h1>
                                            Where Beauty, Skill, and Style Come Together
                                        </h1>
                                        <div className=''>
                                            <p>
                                                Transform your look and your career  with P.A.S. Glam Beauty Studio & Institute,
                                                a premier destination for Makeup, Hair, and Beautician Courses in Pune.
                                            </p>
                                        </div>
                                        <div className='Home-Silder-btn-Main '>
                                            <Link to="services">
                                                <button className='HomeSlideBtn1'>
                                                    See Our Services
                                                </button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
                            <span class="carousel-control NextPrevButton" aria-hidden="true">
                                <i class="fa-solid fa-angle-left"></i>
                            </span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
                            <span class="carousel-control NextPrevButton" aria-hidden="true">
                                <i class="fa-solid fa-angle-right"></i>
                            </span>
                        </button>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="container">
                        <div className="row d-flex justify-content-center ">
                            <div className='HomeInfo'>
                                <div >
                                    <p>
                                        <b> At P.A.S. Glam Beauty Studio & Institute, beauty </b> isn’t just about appearance — it’s about confidence, creativity, and passion.
                                        From flawless Bridal and Party makeup to certified Beautician Training, we bring you a full spectrum of beauty care and education.
                                        Our professionals use trusted Beauty products and Techniques to deliver exceptional salon experiences and hands-on learning for every student.
                                    </p>
                                    <p>
                                        We are proud to be one of Pune’s leading Beauty studios and
                                        Institutes, helping clients shine and students
                                        succeed with skill-based training, expert guidance, and a touch of glam.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="whatsApp">
                <a href="https://wa.me/+919921589794?text=">
                    <i class="fa-brands fa-whatsapp" ></i>
                </a>
            </section>

        </>
    )
}

export default Home